import React from "react"
import "./section7.scss"
import {Tabs, Carousel} from 'antd';
import data from "../data.json";
import Lightbox from "react-image-lightbox";
import 'react-image-lightbox/style.css'
const {TabPane} = Tabs;
const classroom = data.classroom
const livingroom = data.livingroom

class Section7 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            photoIndex: 0,
            isOpen: false,
            group: []
        };
    }

    componentDidMount() {
    }

    render() {
        const {photoIndex, isOpen, group} = this.state;
        return (
            <>
                <Tabs className={"section7-tabs"} defaultActiveKey="1">
                    <TabPane tab="教学环境" key="1">
                        <Carousel dots={false}>{
                            classroom.map((item, index) => {
                                return <div key={index} className={"classroom"}>
                                        <img src={item} alt=""/>
                                    </div>
                            })
                        }
                        </Carousel>
                        <div className={"front"}>
                            <div
                                className="text">
                                全Mac教室<br/>
                                苹果电脑可谓是专业设计师标配工具, Sketch、Principle等高效专业设计软件都需要mac OS系统支持。
                            </div>
                            <div className="btn" onClick={()=>{
                                this.setState({
                                    isOpen: true,
                                    group: classroom,
                                    photoIndex: 0
                                })
                            }}>查看更多</div>
                        </div>
                    </TabPane>
                    <TabPane tab="住宿环境" key="2">
                        <Carousel autoplay dots={false}>{
                            livingroom.map((item, index) => {
                                return <div key={index} className={"livingroom"}>
                                    <img src={item} alt=""/>
                                </div>
                            })
                        }
                        </Carousel>
                        <div className={"front"}>
                            <div className="text">周边住宿条件非常便利，民宿距离学校大约10分钟距离。 价格大概800-1500区间， 可根据个人需要进行选择。学校可以帮助有需要的同学联系，建议开学前跟其他同学合租（2人）。
                            </div>
                            <div className="btn" onClick={()=>{
                                this.setState({
                                    isOpen: true,
                                    group: livingroom,
                                    photoIndex: 0
                                })
                            }}>查看更多</div>
                        </div>
                    </TabPane>
                </Tabs>
                {isOpen && (
                    <Lightbox
                        mainSrc={group[photoIndex]}
                        nextSrc={group[(photoIndex + 1) % group.length]}
                        prevSrc={group[(photoIndex + group.length - 1) % group.length]}
                        onCloseRequest={() => this.setState({isOpen: false})}
                        onMovePrevRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + group.length - 1) % group.length,
                            })
                        }
                        onMoveNextRequest={() =>
                            this.setState({
                                photoIndex: (photoIndex + 1) % group.length,
                            })
                        }
                    />
                )}
            </>
        )
    }
}

export default Section7

